import { useEffect, useState } from "react";

export default function useDebouncedValue(value, delay = 500) {
  const searchvalue = value?.trim();
  const [debounced, setDebounced] = useState(searchvalue);

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(searchvalue), delay);
    return () => clearTimeout(handler);
  }, [searchvalue, delay]);

  return debounced;
}
